/**
 * Helper for managing EveryAction forms callbacks
 **/
export class FormCallbacks {
  constructor(host) {
    // eslint-disable-next-line camelcase
    host.nvtag_callbacks = host.nvtag_callbacks || {};
    this._callbacks = host.nvtag_callbacks;
  }

  add(event, handler) {
    this._callbacks[event] = this._callbacks[event] || [];
    this._callbacks[event].push(handler);
  }
}
